module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(!_vm.down) ? _c('icon', {
    staticClass: "pull-down-button__arrowPosition",
    attrs: {
      "name": "caret-up",
      "scale": "1.2"
    }
  }) : _c('icon', {
    staticClass: "pull-down-button__arrowPosition",
    attrs: {
      "name": "caret-down",
      "scale": "1.2"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d6b866a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/icons/CollapseArrows.vue
// module id = 1872
// module chunks = 0